export const INDICATOR_PERCENTAGE_VARIATION = "INDICATOR_PERCENTAGE_VARIATION";
export const INDICATOR_AVERAGE_ANNUAL_PERCENTAGE_VARIATION = "INDICATOR_AVERAGE_ANNUAL_PERCENTAGE_VARIATION";
export const INDICATOR_AVERAGE_ANNUAL_GROWTH_RATE = "INDICATOR_AVERAGE_ANNUAL_GROWTH_RATE";

export const YEAR_SELECT_WIDTH = 240;
